class TipoStatusEnum {
    constructor(cod, desc) {
      this.cod = cod;
      this.desc = desc;
    }
  
    static fromcod(cod) {
      return Object.values(TipoStatusEnum).find(status => status.cod === cod);
    }
  
    static fromDesc(desc) {
      return Object.values(TipoStatusEnum).find(status => status.desc === desc);
    }
  }
  
  TipoStatusEnum.ITEM_BEM_PERMANENTE = new TipoStatusEnum(6, "Item Bem Permanente");
  TipoStatusEnum.SOLICITACAO_MOVIMENTACAO_ITEM_BEM_PERMANENTE = new TipoStatusEnum(13, "Solicitação Movimentação de Item Bem permanente");
  TipoStatusEnum.IBP_SOLICITACAO_MOVIMENTACAO_ITEM_BEM_PERMANENTE = new TipoStatusEnum(22, "IBP Solicitação Movimentacao IBP");
  TipoStatusEnum.TAREFA_SOL_MOV_IBP = new TipoStatusEnum(50, "Tarefa Solicitação Movimentação Item Bem Permanente");
  TipoStatusEnum.SOLICITACAO_INVENTARIO = new TipoStatusEnum(56, "Solicitação Inventário Item Bem Permanente");

  TipoStatusEnum.ITEM_PLANILHA_RETIFICADORA = new TipoStatusEnum(63, "Planilha Retificadora");
  TipoStatusEnum.PERIODO = new TipoStatusEnum(65, "Período");

  
  TipoStatusEnum.AVALIACAO_IBP = new TipoStatusEnum(67, "Avaliação Item Bem Permanente");
  TipoStatusEnum.LOTE_AVALIACAO_IBP = new TipoStatusEnum(68, "Lote Avaliação Item Bem Permanente");


  export default TipoStatusEnum;